import cookie from 'js-cookie';

const VERIFICATION_STATUS_COOKIE_KEY = 'verification_status';
const LARGE_DIVIDEND_ALERT_KEY = 'large_dividend_alert';

// 招待者のUserIdをCookieから取得
export const getVerificationStatusCookie = (): string | undefined => {
  return cookie.get(VERIFICATION_STATUS_COOKIE_KEY) || undefined;
};

// 招待者のUserIdをCookieにセット
export const setVerificationStatusCookie = (status: string) =>
  cookie.set(VERIFICATION_STATUS_COOKIE_KEY, status, {
    path: '/',
    expires: 365,
  });

export const getLargeDividendAlertCookie = (
  refundAmount: number,
): string | undefined => {
  return cookie.get(`${LARGE_DIVIDEND_ALERT_KEY}_${refundAmount}`) || undefined;
};

export const setLargeDividendAlertCookie = (
  status: string,
  refundAmount: number,
) => {
  cookie.set(`${LARGE_DIVIDEND_ALERT_KEY}_${refundAmount}`, status, {
    path: '/',
    expires: 12,
  });
};
